var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 17.5263 6.47368 22 12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12ZM8 15C8 14.7193 8.10526 14.4737 8.29825 14.2982L10.5789 12L8.29825 9.70176C8.10526 9.52632 8 9.2807 8 9C8 8.45614 8.45614 8 9 8C9.2807 8 9.52632 8.10526 9.70175 8.29825L12 10.5789L14.2982 8.29825C14.4737 8.10526 14.7193 8 15 8C15.5439 8 16 8.45614 16 9C16 9.2807 15.8947 9.52632 15.7018 9.70176L13.4211 12L15.7018 14.2982C15.8947 14.4737 16 14.7193 16 15C16 15.5439 15.5439 16 15 16C14.7193 16 14.4737 15.8947 14.2982 15.7018L12 13.4211L9.70175 15.7018C9.52632 15.8947 9.2807 16 9 16C8.45614 16 8 15.5439 8 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.023f9497.svg";
export { ForwardRef as ReactComponent };